import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d6bd8c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "nge-dsp-topbar"
}
const _hoisted_2 = {
  key: 1,
  class: "nge-dsp-hero"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-dsp-hero-grid" }, null, -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-dsp-title-rule" }, null, -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "nge-dsp-title" }, "Dataset Stats", -1 /* HOISTED */))
const _hoisted_6 = { class: "nge-dsp-title-sub" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-dsp-title-rule" }, null, -1 /* HOISTED */))
const _hoisted_8 = {
  key: 2,
  class: "nge-dsp-tabs",
  role: "tablist",
  "aria-label": "Dataset"
}
const _hoisted_9 = ["aria-selected", "onClick"]
const _hoisted_10 = {
  key: 3,
  class: "nge-dsp-wide-title"
}
const _hoisted_11 = { class: "nge-dsp-content" }
const _hoisted_12 = {
  key: 0,
  class: "nge-dsp-loading",
  role: "status"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-dsp-loading-text" }, "Reading the dataset", -1 /* HOISTED */))
const _hoisted_14 = {
  key: 1,
  class: "nge-dsp-note",
  role: "status"
}
const _hoisted_15 = {
  key: 2,
  class: "nge-dsp-note",
  role: "status"
}
const _hoisted_16 = { class: "nge-dsp-section nge-dsp-s-prog" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-dsp-label" }, "▌ Cells completed", -1 /* HOISTED */))
const _hoisted_18 = {
  key: 0,
  class: "nge-dsp-na"
}
const _hoisted_19 = { class: "nge-dsp-big" }
const _hoisted_20 = { class: "nge-dsp-big-num" }
const _hoisted_21 = { class: "nge-dsp-big-sub" }
const _hoisted_22 = {
  key: 0,
  class: "nge-dsp-scale"
}
const _hoisted_23 = ["href"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-dsp-foot" }, "From this dataset's own records, read once a night. The work was done outside the game, so it does not count toward Achievements or the leaderboard.", -1 /* HOISTED */))
const _hoisted_25 = {
  key: 2,
  class: "nge-dsp-empty"
}
const _hoisted_26 = { class: "nge-dsp-big" }
const _hoisted_27 = { class: "nge-dsp-big-num" }
const _hoisted_28 = { class: "nge-dsp-big-sub" }
const _hoisted_29 = ["aria-label"]
const _hoisted_30 = { class: "nge-dsp-trio" }
const _hoisted_31 = { class: "nge-dsp-tile" }
const _hoisted_32 = { class: "nge-dsp-tile-num nge-dsp-c-done" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-dsp-tile-key" }, "completed", -1 /* HOISTED */))
const _hoisted_34 = { class: "nge-dsp-tile" }
const _hoisted_35 = { class: "nge-dsp-tile-num nge-dsp-c-claimed" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-dsp-tile-key" }, "claimed", -1 /* HOISTED */))
const _hoisted_37 = { class: "nge-dsp-tile" }
const _hoisted_38 = { class: "nge-dsp-tile-num nge-dsp-c-left" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-dsp-tile-key" }, "waiting", -1 /* HOISTED */))
const _hoisted_40 = {
  key: 0,
  class: "nge-dsp-foot"
}
const _hoisted_41 = {
  key: 0,
  class: "nge-dsp-section nge-dsp-s-week"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-dsp-label" }, "▌ Cells per week", -1 /* HOISTED */))
const _hoisted_43 = {
  key: 0,
  class: "nge-dsp-na"
}
const _hoisted_44 = {
  key: 1,
  class: "nge-dsp-empty"
}
const _hoisted_45 = {
  key: 0,
  class: "nge-dsp-readout"
}
const _hoisted_46 = { class: "nge-dsp-readout-week" }
const _hoisted_47 = { class: "nge-dsp-readout-num" }
const _hoisted_48 = { class: "nge-dsp-readout-run" }
const _hoisted_49 = ["viewBox", "aria-label"]
const _hoisted_50 = ["y1", "y2"]
const _hoisted_51 = ["x", "y", "width", "height"]
const _hoisted_52 = ["d"]
const _hoisted_53 = { class: "nge-dsp-axis" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-dsp-legend" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "nge-dsp-key nge-dsp-key--bar" }),
    /*#__PURE__*/_createTextVNode("cells that week")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "nge-dsp-key nge-dsp-key--line" }),
    /*#__PURE__*/_createTextVNode("running total")
  ])
], -1 /* HOISTED */))
const _hoisted_55 = {
  key: 1,
  class: "nge-dsp-foot"
}
const _hoisted_56 = {
  key: 1,
  class: "nge-dsp-section nge-dsp-s-types"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-dsp-label" }, "▌ By predicted cell type", -1 /* HOISTED */))
const _hoisted_58 = {
  key: 0,
  class: "nge-dsp-na"
}
const _hoisted_59 = {
  key: 1,
  class: "nge-dsp-types"
}
const _hoisted_60 = ["title"]
const _hoisted_61 = { class: "nge-dsp-type-track" }
const _hoisted_62 = { class: "nge-dsp-type-count" }
const _hoisted_63 = { class: "nge-dsp-type-of" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-dsp-foot" }, "Finished out of all cells of that type. Types are the classifier's prediction from the cell list.", -1 /* HOISTED */))
const _hoisted_65 = { class: "nge-dsp-section nge-dsp-s-work" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-dsp-label" }, "▌ Work in EyeWire II", -1 /* HOISTED */))
const _hoisted_67 = {
  key: 0,
  class: "nge-dsp-na"
}
const _hoisted_68 = {
  key: 1,
  class: "nge-dsp-empty"
}
const _hoisted_69 = { class: "nge-dsp-trio" }
const _hoisted_70 = { class: "nge-dsp-tile" }
const _hoisted_71 = { class: "nge-dsp-tile-num" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-dsp-tile-key" }, "edits", -1 /* HOISTED */))
const _hoisted_73 = { class: "nge-dsp-tile" }
const _hoisted_74 = { class: "nge-dsp-tile-num nge-dsp-c-ann" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-dsp-tile-key" }, "annotations", -1 /* HOISTED */))
const _hoisted_76 = { class: "nge-dsp-tile" }
const _hoisted_77 = { class: "nge-dsp-tile-num nge-dsp-c-people" }
const _hoisted_78 = { class: "nge-dsp-tile-key" }
const _hoisted_79 = ["aria-label"]
const _hoisted_80 = { class: "nge-dsp-splitkey" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "nge-dsp-key nge-dsp-key--split" }, null, -1 /* HOISTED */))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "nge-dsp-key nge-dsp-key--merge" }, null, -1 /* HOISTED */))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-dsp-foot" }, "Edits and annotations made in the game. Work done outside it is not counted here. Annotations are counted per dataset from October 2026 on.", -1 /* HOISTED */))
const _hoisted_84 = {
  key: 2,
  class: "nge-dsp-section nge-dsp-section--mine nge-dsp-s-mine"
}
const _hoisted_85 = { class: "nge-dsp-label nge-dsp-label--amber" }
const _hoisted_86 = { class: "nge-dsp-mine" }
const _hoisted_87 = { class: "nge-dsp-mine-row" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-dsp-mine-key" }, "Cells completed", -1 /* HOISTED */))
const _hoisted_89 = {
  key: 0,
  class: "nge-dsp-mine-na"
}
const _hoisted_90 = { class: "nge-dsp-mine-num" }
const _hoisted_91 = {
  key: 0,
  class: "nge-dsp-mine-share"
}
const _hoisted_92 = {
  key: 0,
  class: "nge-dsp-mine-note"
}
const _hoisted_93 = {
  key: 1,
  class: "nge-dsp-mine-row"
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-dsp-mine-key" }, "Edits", -1 /* HOISTED */))
const _hoisted_95 = {
  key: 0,
  class: "nge-dsp-mine-na"
}
const _hoisted_96 = { class: "nge-dsp-mine-num" }
const _hoisted_97 = {
  key: 0,
  class: "nge-dsp-mine-share"
}
const _hoisted_98 = {
  key: 2,
  class: "nge-dsp-mine-row"
}
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-dsp-mine-key" }, "Annotations", -1 /* HOISTED */))
const _hoisted_100 = {
  key: 0,
  class: "nge-dsp-mine-na"
}
const _hoisted_101 = { class: "nge-dsp-mine-num" }
const _hoisted_102 = {
  key: 0,
  class: "nge-dsp-mine-share"
}
const _hoisted_103 = {
  key: 0,
  class: "nge-dsp-foot"
}
const _hoisted_104 = {
  key: 1,
  class: "nge-dsp-foot"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent($setup.props.embedded ? 'div' : $setup.ModalOverlay), {
    id: $setup.props.embedded ? undefined : 'nge-dsp-modal',
    class: _normalizeClass($setup.props.embedded ? 'nge-dsp-embedded' : ['nge-dsp-modal', { 'nge-dsp-modal--peek': $setup.props.peek }]),
    onHide: _cache[2] || (_cache[2] = $event => ($setup.emit('hide')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["nge-dsp-shell", { 'nge-dsp-shell--wide': $setup.props.embedded }])
      }, [
        (!$setup.props.embedded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("button", {
                class: "nge-dsp-exit",
                "aria-label": "Close",
                onClick: _cache[0] || (_cache[0] = $event => ($setup.emit('hide')))
              }, "×")
            ]))
          : _createCommentVNode("v-if", true),
        (!$setup.props.embedded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _hoisted_4,
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, _toDisplayString($setup.active ? $setup.active.label : 'What has been done on each dataset'), 1 /* TEXT */),
              _hoisted_7
            ]))
          : _createCommentVNode("v-if", true),
        ($setup.datasets.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.datasets, (ds) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: ds.id,
                  role: "tab",
                  class: _normalizeClass(["nge-dsp-tab", { 'nge-dsp-tab--active': $setup.active === ds }]),
                  "aria-selected": $setup.active === ds,
                  onClick: $event => ($setup.pick(ds))
                }, _toDisplayString(ds.shortLabel), 11 /* TEXT, CLASS, PROPS */, _hoisted_9))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        ($setup.props.embedded && $setup.active)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($setup.active.label), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_11, [
          _createCommentVNode(" Whole panel states "),
          ($setup.phase === 'loading' || ($setup.phase === 'ready' && $setup.active && !$setup.stats))
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode($setup["GrowingCell"], { size: 110 }),
                _hoisted_13
              ]))
            : ($setup.phase === 'unavailable')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Dataset stats are not available right now. Nothing is shown rather than a guess. "))
              : (!$setup.datasets.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, " No dataset has a cell list or logged work yet. "))
                : ($setup.stats)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createCommentVNode(" ── Progress ── "),
                      _createElementVNode("section", _hoisted_16, [
                        _hoisted_17,
                        (!$setup.progress)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Not available right now."))
                          : (!$setup.hasList && $setup.outsideCells > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("div", _hoisted_19, [
                                  _createElementVNode("span", _hoisted_20, [
                                    _createVNode($setup["RollUp"], { value: $setup.outsideCells }, null, 8 /* PROPS */, ["value"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_21, " cell" + _toDisplayString($setup.outsideCells === 1 ? '' : 's') + " proofread by EyeWire II players ", 1 /* TEXT */),
                                ($setup.active?.published)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                      _createTextVNode(" The whole dataset has "),
                                      _createElementVNode("strong", null, _toDisplayString($setup.active.published.cells.toLocaleString()), 1 /* TEXT */),
                                      _createTextVNode(" proofread cells ("),
                                      _createElementVNode("a", {
                                        href: $setup.active.published.url,
                                        target: "_blank",
                                        rel: "noopener"
                                      }, _toDisplayString($setup.active.published.source), 9 /* TEXT, PROPS */, _hoisted_23),
                                      _createTextVNode("). ")
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                _hoisted_24
                              ], 64 /* STABLE_FRAGMENT */))
                            : (!$setup.hasList)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, "This dataset has no cell list yet, so there is no total to measure against."))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                  _createCommentVNode(" The headline is the count, not a percentage (Ames 2026-10-06). "),
                                  _createElementVNode("div", _hoisted_26, [
                                    _createElementVNode("span", _hoisted_27, [
                                      _createVNode($setup["RollUp"], {
                                        value: $setup.progress.done
                                      }, null, 8 /* PROPS */, ["value"])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_28, [
                                    _createTextVNode(" cell" + _toDisplayString($setup.progress.done === 1 ? '' : 's') + " completed, of ", 1 /* TEXT */),
                                    _createElementVNode("strong", null, _toDisplayString($setup.progress.total.toLocaleString()), 1 /* TEXT */),
                                    _createTextVNode(" in the cell list ")
                                  ]),
                                  _createElementVNode("div", {
                                    class: "nge-dsp-track",
                                    role: "img",
                                    "aria-label": `${$setup.progress.done.toLocaleString()} completed, ${$setup.progress.claimed.toLocaleString()} claimed, ${$setup.progress.waiting.toLocaleString()} waiting`
                                  }, [
                                    _createElementVNode("div", {
                                      class: "nge-dsp-fill nge-dsp-fill--done",
                                      style: _normalizeStyle({ width: $setup.pctDone + '%' })
                                    }, null, 4 /* STYLE */),
                                    _createElementVNode("div", {
                                      class: "nge-dsp-fill nge-dsp-fill--claimed",
                                      style: _normalizeStyle({ width: $setup.pctClaimed + '%' })
                                    }, null, 4 /* STYLE */)
                                  ], 8 /* PROPS */, _hoisted_29),
                                  _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("div", _hoisted_31, [
                                      _createElementVNode("div", _hoisted_32, _toDisplayString($setup.progress.done.toLocaleString()), 1 /* TEXT */),
                                      _hoisted_33
                                    ]),
                                    _createElementVNode("div", _hoisted_34, [
                                      _createElementVNode("div", _hoisted_35, _toDisplayString($setup.progress.claimed.toLocaleString()), 1 /* TEXT */),
                                      _hoisted_36
                                    ]),
                                    _createElementVNode("div", _hoisted_37, [
                                      _createElementVNode("div", _hoisted_38, _toDisplayString($setup.progress.waiting.toLocaleString()), 1 /* TEXT */),
                                      _hoisted_39
                                    ])
                                  ]),
                                  ($setup.progress.setAside > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString($setup.progress.setAside.toLocaleString()) + " more were set aside (retired, could not be completed, or not this kind of cell) and are not in the total. ", 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true)
                                ], 64 /* STABLE_FRAGMENT */))
                      ]),
                      _createCommentVNode(" ── Cells per week ── "),
                      ($setup.hasList || (!$setup.outsideCells && $setup.stats.weeks && $setup.stats.weeks.length))
                        ? (_openBlock(), _createElementBlock("section", _hoisted_41, [
                            _hoisted_42,
                            (!$setup.stats.weeks)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_43, "Not available right now."))
                              : (!$setup.hasCellWeeks)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_44, " No finished cell has a recorded date yet. "))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    ($setup.shownWeek)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                          _createElementVNode("span", _hoisted_46, "Week of " + _toDisplayString($setup.weekLabel($setup.shownWeek.weekStart)), 1 /* TEXT */),
                                          _createElementVNode("span", _hoisted_47, _toDisplayString($setup.shownWeek.cells.toLocaleString()) + " cell" + _toDisplayString($setup.shownWeek.cells === 1 ? '' : 's'), 1 /* TEXT */),
                                          _createElementVNode("span", _hoisted_48, _toDisplayString($setup.shownWeek.running.toLocaleString()) + " so far", 1 /* TEXT */)
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    (_openBlock(), _createElementBlock("svg", {
                                      class: "nge-dsp-chart",
                                      viewBox: `0 0 ${$setup.CHART_W} ${$setup.CHART_H}`,
                                      preserveAspectRatio: "none",
                                      role: "img",
                                      "aria-label": `Cells finished each week, ${$setup.series.length} weeks`,
                                      onPointermove: $setup.onChartPoint,
                                      onPointerdown: $setup.onChartPoint,
                                      onPointerleave: _cache[1] || (_cache[1] = $event => ($setup.hoverWeek = null))
                                    }, [
                                      _createElementVNode("line", {
                                        class: "nge-dsp-chart-base",
                                        x1: "0",
                                        y1: $setup.CHART_H - 0.5,
                                        x2: $setup.CHART_W,
                                        y2: $setup.CHART_H - 0.5
                                      }, null, 8 /* PROPS */, _hoisted_50),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.bars, (b) => {
                                        return (_openBlock(), _createElementBlock("rect", {
                                          key: b.weekStart,
                                          class: _normalizeClass(["nge-dsp-bar", { 'nge-dsp-bar--on': $setup.shownWeek && $setup.shownWeek.weekStart === b.weekStart }]),
                                          x: b.x,
                                          y: b.y,
                                          width: b.w,
                                          height: b.h,
                                          style: _normalizeStyle({ animationDelay: Math.min(b.i * 14, 600) + 'ms' })
                                        }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_51))
                                      }), 128 /* KEYED_FRAGMENT */)),
                                      ($setup.runningPath)
                                        ? (_openBlock(), _createElementBlock("path", {
                                            key: 0,
                                            class: "nge-dsp-run",
                                            d: $setup.runningPath
                                          }, null, 8 /* PROPS */, _hoisted_52))
                                        : _createCommentVNode("v-if", true)
                                    ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_49)),
                                    _createElementVNode("div", _hoisted_53, [
                                      _createElementVNode("span", null, _toDisplayString($setup.shortDate($setup.series[0].weekStart)), 1 /* TEXT */),
                                      _createElementVNode("span", null, "most in a week: " + _toDisplayString($setup.weekMax.toLocaleString()), 1 /* TEXT */),
                                      _createElementVNode("span", null, _toDisplayString($setup.shortDate($setup.series[$setup.series.length - 1].weekStart)), 1 /* TEXT */)
                                    ]),
                                    _hoisted_54,
                                    ($setup.progress && $setup.progress.undated > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString($setup.progress.undated.toLocaleString()) + " finished cell" + _toDisplayString($setup.progress.undated === 1 ? ' has' : 's have') + " no recorded date, so " + _toDisplayString($setup.progress.undated === 1 ? 'it is' : 'they are') + " not in this chart. ", 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true)
                                  ], 64 /* STABLE_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true),
                      _createCommentVNode(" ── By cell type ── "),
                      ($setup.hasList && (!$setup.stats.types || $setup.hasTypes))
                        ? (_openBlock(), _createElementBlock("section", _hoisted_56, [
                            _hoisted_57,
                            (!$setup.stats.types)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_58, "Not available right now."))
                              : (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.typeRows, (r, i) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: r.type ?? '(none)',
                                      class: "nge-dsp-type",
                                      title: `${r.done.toLocaleString()} finished, ${r.left.toLocaleString()} left`
                                    }, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["nge-dsp-type-name", { 'nge-dsp-type-name--none': r.type === null }])
                                      }, _toDisplayString(r.type ?? 'No type'), 3 /* TEXT, CLASS */),
                                      _createElementVNode("span", _hoisted_61, [
                                        _createElementVNode("i", {
                                          class: "nge-dsp-type-fill",
                                          style: _normalizeStyle({ width: r.pct + '%', animationDelay: Math.min(i * 30, 600) + 'ms' })
                                        }, null, 4 /* STYLE */)
                                      ]),
                                      _createElementVNode("span", _hoisted_62, [
                                        _createTextVNode(_toDisplayString(r.done.toLocaleString()), 1 /* TEXT */),
                                        _createElementVNode("span", _hoisted_63, " / " + _toDisplayString(r.total.toLocaleString()), 1 /* TEXT */)
                                      ])
                                    ], 8 /* PROPS */, _hoisted_60))
                                  }), 128 /* KEYED_FRAGMENT */)),
                                  _hoisted_64
                                ]))
                          ]))
                        : _createCommentVNode("v-if", true),
                      _createCommentVNode(" ── Work in the game ── "),
                      _createElementVNode("section", _hoisted_65, [
                        _hoisted_66,
                        (!$setup.work)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_67, "Not available right now."))
                          : ($setup.nothingHere)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_68, "No edits have been logged on this dataset yet."))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createElementVNode("div", _hoisted_69, [
                                  _createElementVNode("div", _hoisted_70, [
                                    _createElementVNode("div", _hoisted_71, [
                                      _createVNode($setup["RollUp"], {
                                        value: $setup.work.edits
                                      }, null, 8 /* PROPS */, ["value"])
                                    ]),
                                    _hoisted_72
                                  ]),
                                  _createElementVNode("div", _hoisted_73, [
                                    _createElementVNode("div", _hoisted_74, [
                                      _createVNode($setup["RollUp"], {
                                        value: $setup.work.annotations
                                      }, null, 8 /* PROPS */, ["value"])
                                    ]),
                                    _hoisted_75
                                  ]),
                                  _createElementVNode("div", _hoisted_76, [
                                    _createElementVNode("div", _hoisted_77, [
                                      _createVNode($setup["RollUp"], {
                                        value: $setup.work.players
                                      }, null, 8 /* PROPS */, ["value"])
                                    ]),
                                    _createElementVNode("div", _hoisted_78, _toDisplayString($setup.work.players === 1 ? 'person' : 'people') + " editing", 1 /* TEXT */)
                                  ])
                                ]),
                                ($setup.work.edits > 0)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("div", {
                                        class: "nge-dsp-track nge-dsp-track--split",
                                        role: "img",
                                        "aria-label": `${$setup.work.splits.toLocaleString()} splits, ${$setup.work.merges.toLocaleString()} merges`
                                      }, [
                                        _createElementVNode("div", {
                                          class: "nge-dsp-fill nge-dsp-fill--split",
                                          style: _normalizeStyle({ width: $setup.pctSplits + '%' })
                                        }, null, 4 /* STYLE */),
                                        _createElementVNode("div", {
                                          class: "nge-dsp-fill nge-dsp-fill--merge",
                                          style: _normalizeStyle({ width: (100 - $setup.pctSplits) + '%' })
                                        }, null, 4 /* STYLE */)
                                      ], 8 /* PROPS */, _hoisted_79),
                                      _createElementVNode("div", _hoisted_80, [
                                        _createElementVNode("span", null, [
                                          _hoisted_81,
                                          _createTextVNode(_toDisplayString($setup.work.splits.toLocaleString()) + " splits", 1 /* TEXT */)
                                        ]),
                                        _createElementVNode("span", null, [
                                          _hoisted_82,
                                          _createTextVNode(_toDisplayString($setup.work.merges.toLocaleString()) + " merges", 1 /* TEXT */)
                                        ])
                                      ])
                                    ], 64 /* STABLE_FRAGMENT */))
                                  : _createCommentVNode("v-if", true),
                                _hoisted_83
                              ], 64 /* STABLE_FRAGMENT */))
                      ]),
                      _createCommentVNode(" ── Your part ── "),
                      ($setup.mine)
                        ? (_openBlock(), _createElementBlock("section", _hoisted_84, [
                            _createElementVNode("div", _hoisted_85, "▌ " + _toDisplayString($setup.partTitle), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_86, [
                              _createElementVNode("div", _hoisted_87, [
                                _hoisted_88,
                                ($setup.mine.cells === null)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_89, "not available"))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createElementVNode("span", _hoisted_90, _toDisplayString($setup.mine.cells.toLocaleString()), 1 /* TEXT */),
                                      ($setup.hasList && $setup.progress)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_91, _toDisplayString($setup.shareText($setup.mine.cells, $setup.progress.total)) + " of the dataset", 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true)
                                    ], 64 /* STABLE_FRAGMENT */))
                              ]),
                              _createCommentVNode(" Two honest numbers that differ (Nseraf 2026-10-07: 4,805 here,\n                   760 in his profile): say which one this is. "),
                              ($setup.hasList && $setup.mine.cells !== null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_92, " Counted from the lab's spreadsheet, so it includes cells finished before Pyr. A profile counts only cells completed in Pyr. "))
                                : _createCommentVNode("v-if", true),
                              ($setup.hasList || !$setup.outsideCells || $setup.mine.edits)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                    _hoisted_94,
                                    ($setup.mine.edits === null)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_95, "not available"))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createElementVNode("span", _hoisted_96, _toDisplayString($setup.mine.edits.toLocaleString()), 1 /* TEXT */),
                                          ($setup.work && $setup.work.edits > 0)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_97, _toDisplayString($setup.shareText($setup.mine.edits, $setup.work.edits)) + " of all edits here", 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true)
                                        ], 64 /* STABLE_FRAGMENT */))
                                  ]))
                                : _createCommentVNode("v-if", true),
                              ($setup.hasList || !$setup.outsideCells || $setup.mine.annotations)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                    _hoisted_99,
                                    ($setup.mine.annotations === null)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_100, "not available"))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createElementVNode("span", _hoisted_101, _toDisplayString($setup.mine.annotations.toLocaleString()), 1 /* TEXT */),
                                          ($setup.work && $setup.work.annotations > 0)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_102, _toDisplayString($setup.shareText($setup.mine.annotations, $setup.work.annotations)) + " of all annotations here", 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true)
                                        ], 64 /* STABLE_FRAGMENT */))
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ]),
                            ($setup.hasList)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_103, "Cells are the ones under " + _toDisplayString($setup.props.person ? 'their' : 'your') + " name in the cell list.", 1 /* TEXT */))
                              : ($setup.outsideCells)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_104, "Cells are the ones " + _toDisplayString($setup.props.person ? 'they' : 'you') + " completed in the game. The number above is from the dataset's own records and counts work done outside it.", 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
        ]),
        ($setup.readAt)
          ? (_openBlock(), _createElementBlock("div", {
              key: 4,
              class: _normalizeClass(["nge-dsp-readat", { 'nge-dsp-readat--busy': $setup.reading }])
            }, "Read at " + _toDisplayString($setup.readAt), 3 /* TEXT, CLASS */))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */)
    ]),
    _: 1 /* STABLE */
  }, 40 /* PROPS, HYDRATE_EVENTS */, ["id", "class"]))
}